var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenchmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.224121,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3F46AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3343_8910",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.22412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3343_8910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 24.2241C21.45 24.2241 20.9792 24.0283 20.5875 23.6366C20.1958 23.245 20 22.7741 20 22.2241V19.2241C20 18.6741 20.1958 18.2033 20.5875 17.8116C20.9792 17.42 21.45 17.2241 22 17.2241C22.55 17.2241 23.0208 17.42 23.4125 17.8116C23.8042 18.2033 24 18.6741 24 19.2241V22.2241C24 22.7741 23.8042 23.245 23.4125 23.6366C23.0208 24.0283 22.55 24.2241 22 24.2241ZM16 24.2241C15.45 24.2241 14.9792 24.0283 14.5875 23.6366C14.1958 23.245 14 22.7741 14 22.2241V10.2241C14 9.67412 14.1958 9.20329 14.5875 8.81162C14.9792 8.41995 15.45 8.22412 16 8.22412C16.55 8.22412 17.0208 8.41995 17.4125 8.81162C17.8042 9.20329 18 9.67412 18 10.2241V22.2241C18 22.7741 17.8042 23.245 17.4125 23.6366C17.0208 24.0283 16.55 24.2241 16 24.2241ZM10 24.2241C9.45 24.2241 8.97917 24.0283 8.5875 23.6366C8.19583 23.245 8 22.7741 8 22.2241V15.2241C8 14.6741 8.19583 14.2033 8.5875 13.8116C8.97917 13.42 9.45 13.2241 10 13.2241C10.55 13.2241 11.0208 13.42 11.4125 13.8116C11.8042 14.2033 12 14.6741 12 15.2241V22.2241C12 22.7741 11.8042 23.245 11.4125 23.6366C11.0208 24.0283 10.55 24.2241 10 24.2241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarkIcon);
export default __webpack_public_path__ + "static/media/Benchmark_icon.61d4cc39c1857816c207f67d11df39bd.svg";
export { ForwardRef as ReactComponent };